module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/wearing/wearing-04-c9f96ab236c3c4340e16c3c72982e970.jpg";